module.exports = __webpack_public_path__ + "static/media/Illus-Credit_2@2x.9bead527.png";